// Renewal-status metadata — FE-035.
//
// Single source of truth for ordering, palette, and helper copy
// shared between RenewalLegend and RenewalPipelineChart.

export type RenewalStatusKey =
  | "on_track" | "behind" | "at_risk" | "not_started";


export interface RenewalStatusMeta {
  /** Visible label rendered in the legend. */
  label: string;
  /** Tailwind background class applied to the bar segment + swatch. */
  swatch: string;
  /** Short helper copy for tooltips / aria-labels. */
  helper: string;
}


export const RENEWAL_STATUS_ORDER: RenewalStatusKey[] = [
  "not_started", "at_risk", "behind", "on_track",
];


export const RENEWAL_STATUS_META: Record<RenewalStatusKey, RenewalStatusMeta> = {
  on_track: {
    label: "On track",
    swatch: "bg-sage",
    helper: "Open with future due dates or done on time.",
  },
  behind: {
    label: "Behind",
    swatch: "bg-ember",
    helper: "At least one renewal Commitment is past due.",
  },
  at_risk: {
    label: "At risk",
    swatch: "bg-gold",
    helper: "Closed late — renewal slipped past due.",
  },
  not_started: {
    label: "Not started",
    swatch: "bg-blocked",
    helper: "No renewal Commitments worked yet.",
  },
};
